import { CommonModule } from "@angular/common";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormControl, ReactiveFormsModule, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { SidebarModule } from "primeng/sidebar";
import { Subscription } from "rxjs";
import { schoolConfig } from "src/app/core/config";
import { ButtonDirective } from "src/app/core/directives";
import { DateTimePipe } from "src/app/core/pipes";

import {
    AlertComponent,
    AutocompleteComponent,
    DividerComponent,
    HeadingComponent,
} from "src/app/shared/components/ui";

import { selectIsAdminLoggedIn } from "src/app/core/stores";
import { FRONTEND_DATE_TIME_FORMAT } from "src/app/shared/constants";
import { ChipDirective } from "src/app/shared/directive";
import { AdmissionInstalmentInterface, PaymentMethodEnum, PaymentTypes } from "src/app/shared/interfaces";
import { admissionActions, paymentActions, selectIsMutationLoading, selectOrderData } from "src/app/shared/store";
import { PaymentWarpperComponent } from "../../payment";

@Component({
    selector: "sms-pay-instalment",
    standalone: true,
    imports: [
        CommonModule,
        SidebarModule,
        HeadingComponent,
        ChipDirective,
        ButtonDirective,
        DividerComponent,
        DateTimePipe,
        AlertComponent,
        AutocompleteComponent,
        ReactiveFormsModule,
        PaymentWarpperComponent,
    ],
    providers: [DateTimePipe],
    templateUrl: "./pay-instalment.component.html",
    styleUrls: ["./pay-instalment.component.scss"],
})
export class PayInstalmentComponent implements OnInit, OnDestroy {
    paymentMenthod: FormControl = new FormControl("", [Validators.required]);

    dateTimeFormat = FRONTEND_DATE_TIME_FORMAT;
    paymentMenthodOptions = Object.values(PaymentMethodEnum);
    orderData: any = null;
    onlinePaymentEnabled = schoolConfig.online_payment_enabled;
    isAdmin$ = this.store.select(selectIsAdminLoggedIn);
    isLoading$ = this.store.select(selectIsMutationLoading);
    clickedButton: string = "";
    subscription: Subscription = new Subscription();

    constructor(
        private ref: DynamicDialogRef,
        public config: DynamicDialogConfig,
        private dateTimePipe: DateTimePipe,
        private store: Store,
        public router: Router,
    ) {}

    ngOnInit(): void {
        if (this.onlinePaymentEnabled) {
            if (!this.config.data.is_paid) {
                this.store.dispatch(
                    paymentActions.createOrder({
                        data: {
                            id: this.config.data.id,
                            type: PaymentTypes.INSTALMENT_PAYMENT,
                            admission_instalment_id: this.config.data.id,
                            onClose: this.onClose,
                            payment_method: this.paymentMenthod.getRawValue(),
                        },
                    }),
                );
            }
        } else {
            // this.paymentMenthodOptions = this.paymentMenthodOptions.filter((item) => item !== PaymentMethodEnum.ONLINE);
        }
        this.subscription.add(
            this.store.select(selectOrderData).subscribe((orderData) => {
                this.orderData = orderData;
            }),
        );
        if (this.config.data.payment_method) {
            this.paymentMenthod.patchValue(this.config.data.payment_method);
        }
    }

    payFees() {
        this.clickedButton = "PayFees";
        this.paymentMenthod.markAllAsTouched();
        if (this.paymentMenthod.valid) {
            // if (this.paymentMenthod.getRawValue() !== PaymentMethodEnum.ONLINE) {
            this.store.dispatch(
                admissionActions.payInstalment({
                    onClose: this.onClose,
                    data: {
                        payment_method: this.paymentMenthod.getRawValue(),
                        ins_id: this.config.data.id,
                    },
                }),
            );
            // }
        }
    }

    updateFeesMethod() {
        this.clickedButton = "UpdateFeesMethod";
        this.paymentMenthod.markAllAsTouched();
        if (this.paymentMenthod.valid) {
            this.store.dispatch(
                admissionActions.updatePaymentMethod({
                    onClose: this.onClose,
                    data: {
                        payment_method: this.paymentMenthod.getRawValue(),
                        fees_type: "Instalment Payment",
                        id: this.config.data.id,
                    },
                }),
            );
        }
    }

    getFormatedDate(item: AdmissionInstalmentInterface) {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();

        const createdDate = new Date(currentYear, item.due_in_month - 1, item.due_date);
        return this.dateTimePipe.transform(createdDate);
    }

    onClose = (success: boolean = false) => {
        this.ref.close(success);
    };

    downloadRecipt(instalment_id: string, type: string) {
        this.clickedButton = "DownloadRecipt";
        this.store.dispatch(
            admissionActions.downloadInstalmentRecipt({
                data: {
                    instalment_id,
                    type,
                },
            }),
        );
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}
